import { PLAYBACK_SPEEDS } from "./audio-context.constants";
import { Dispatch, Reducer, RefObject } from "react";

export interface IAudioProviderProps {}

export interface IAudioContext {
    readonly currentTime: number;
    readonly duration: number;
    readonly error: string | null;
    readonly isPlaying: boolean;
    readonly isLoading: boolean;
    readonly isMuted: boolean;
    readonly playbackRate: number;
    readonly volume: number;
    readonly url: string | null;
    readonly audioRef: RefObject<HTMLAudioElement> | null;
}

export enum AudioActions {
    LOAD_AUDIO = "LOAD_AUDIO",
    RESET_CONTEXT = "RESET_CONTEXT",
    SET_CURRENT_TIME = "SET_CURRENT_TIME",
    SET_DURATION = "SET_DURATION",
    SET_ERROR = "SET_ERROR",
    SET_IS_PLAYING = "SET_IS_PLAYING",
    SET_IS_LOADING = "SET_IS_LOADING",
    SET_IS_MUTED = "SET_IS_MUTED",
    SET_PLAYBACK_RATE = "SET_PLAYBACK_RATE",
    SET_VOLUME = "SET_VOLUME",
}
interface AudioReducerActionWithPayload<A extends string, P> {
    readonly type: A;
    readonly payload: P;
}

export type LoadAudioAction = AudioReducerActionWithPayload<
    AudioActions.LOAD_AUDIO,
    {
        readonly url: string;
        readonly audioRef: RefObject<HTMLAudioElement>;
    }
>;
export type ResetContextAction = AudioReducerActionWithPayload<AudioActions.RESET_CONTEXT, IAudioContext>;
export type SetCurrentTimeAction = AudioReducerActionWithPayload<AudioActions.SET_CURRENT_TIME, number>;
export type SetDurationAction = AudioReducerActionWithPayload<AudioActions.SET_DURATION, number>;
export type SetErrorAction = AudioReducerActionWithPayload<AudioActions.SET_ERROR, string | null>;
export type SetIsPlayingAction = AudioReducerActionWithPayload<AudioActions.SET_IS_PLAYING, boolean>;
export type SetIsLoadingAction = AudioReducerActionWithPayload<AudioActions.SET_IS_LOADING, boolean>;
export type SetIsMutedAction = AudioReducerActionWithPayload<AudioActions.SET_IS_MUTED, boolean>;
export type SetPlaybackRateAction = AudioReducerActionWithPayload<
    AudioActions.SET_PLAYBACK_RATE,
    (typeof PLAYBACK_SPEEDS)[number]
>;
export type SetVolumeAction = AudioReducerActionWithPayload<AudioActions.SET_VOLUME, number>;

export type IAudioActions =
    | LoadAudioAction
    | ResetContextAction
    | SetCurrentTimeAction
    | SetDurationAction
    | SetErrorAction
    | SetIsPlayingAction
    | SetIsLoadingAction
    | SetIsMutedAction
    | SetPlaybackRateAction
    | SetVolumeAction;

export type IAudioReducer = Reducer<IAudioContext, IAudioActions>;
export type IAudioDispatch = Dispatch<IAudioActions>;
